import styled from 'styled-components';
import { Layout } from 'antd';
const { Content } = Layout;

export const StyledLayout = styled(Layout)`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(245, 244, 247, 1);
`;

export const StyledMainContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const StyledContent = styled(Content)`
  height: 100%;
  overflow: auto;
`;